export const onChange = async (props, debounced, data) => {
	let slides = props.slideList.slides;
	let slide = slides[props.slideList.activeSlide];
	slide = {
		...slide,
		data,
	};
	slides[props.slideList.activeSlide] = slide;
	props.updateSlides({ slides });
	debounced.callback(props, slide);
};
